import { render, staticRenderFns } from "./LuCOGEntityType.vue?vue&type=template&id=78ac913f&"
import script from "./LuCOGEntityType.vue?vue&type=script&lang=js&"
export * from "./LuCOGEntityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports